// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconQuestionCircle = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12 9a1 1 0 00-1 1H9a3 3 0 116 0v.172a3 3 0 01-.879 2.12L13 13.415V14h-2v-.586A2 2 0 0111.586 12l1.121-1.121a1 1 0 00.293-.707V10a1 1 0 00-1-1m1 6v2h-2v-2z" />,
    <path fillRule="evenodd" d="M12 3a9 9 0 100 18 9 9 0 000-18m-7 9a7 7 0 1114 0 7 7 0 01-14 0" />
  );
export default SvgIconQuestionCircle;
